import React, { FC } from 'react'
import { Button, Card, Col, Form } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface Props {
  emailError: boolean;
  email: string;
  password: string;
  showLoginError: boolean;
  onChangeField: (e: any, name: string) => void;
  onKeyPress: (e: any) => void;
  onLoginUser: (e: any) => void;
}

const LoginUser: FC<Props> = ({emailError, email, password, showLoginError, onChangeField, onKeyPress, onLoginUser}: Props) => {
  let errorMessage = (<div></div>)
  if(emailError)
    errorMessage = (
	  <Form.Text className="login-error-msg">
        <FontAwesomeIcon icon={['fas', 'exclamation-circle']} className="login-error-icon"/>This field requires a valid email address.
	  </Form.Text>
    )
  
  let loginError = (<div></div>)
  if(showLoginError)
    loginError = (
	  <div className="loading-error-msg-2">
        <FontAwesomeIcon icon={['fas', 'exclamation-circle']} className="login-error-icon" size="3x"/>
        <div>
		  <span className="loading-error-msg-span">Sorry, your email and/or password are not correct.</span>
		  <span>Please check them and try again.</span>
        </div>
	  </div>
    ) 
  
  return (
    <Card className="login-card">
	  	<Card.Body className="login-card-body">
        {loginError}
        <Form className='login-form'>
		  		<Form.Group as={Col} lg={12} md={12} sm={12} xs={12}>
            <Form.Label>Email</Form.Label>
            <Form.Control size="lg" className="login-ipt" isInvalid={emailError} onChange={(e: any)=>{onChangeField(e, 'email')}} onKeyPress={onKeyPress}/>
            {errorMessage}
          </Form.Group>
          <Form.Group as={Col} lg={12} md={12} sm={12} xs={12}>
            <Form.Label>Password</Form.Label>
            <Form.Control size="lg" className="login-ipt" type="password" onChange={(e: any)=>{onChangeField(e, 'password')}} onKeyPress={onKeyPress}/>
		  		</Form.Group>
        </Form>
        <Button id="login-btn" disabled={email===''||password===''} onClick={onLoginUser}>Log in</Button>
        <div className="login-forgot-pwd-container">
		  		<Link to="/login/forgot" className="login-forgot-pwd">Forgot password?</Link>
        </div>
	  	</Card.Body>
    </Card>
  )
}
export default LoginUser
